var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect } from "react";
import { RequerimentoCustomRadioGroup } from "../../../../components/RequerimentoCustomRadioGroup";
import { useRequerimentoContext } from "../context/RequerimentoContext";
import { TipoDocumentoEnum, TipoDocumentoOptions } from "../../../../model/enums/TipoDocumentoEnum";
import { Box } from '@mui/material';
import { LocalStorageUtils } from "../../../../util/LocalStorageUtils";
import { AuthConstants } from "../../../../util/auth-constants";
import { TipoProcessoEnum } from "../../../../model/enums/TipoProcessoEnum";
export var TipoRequerenteDoc = function (_a) {
    var requerimentoFieldErrorChange = _a.requerimentoFieldErrorChange;
    var _b = useRequerimentoContext(), tipoRequerenteDoc = _b.tipoRequerenteDoc, setTipoRequerenteDoc = _b.setTipoRequerenteDoc, _requerimento = _b._requerimento;
    var requerimento = _requerimento[0], setRequerimento = _requerimento[1];
    useEffect(function () {
    }, [requerimento, tipoRequerenteDoc]);
    var handleChange = function (event) {
        var value = event.target.value;
        setTipoRequerenteDoc(value);
        if (value === TipoDocumentoEnum.PF) {
            setRequerimento(function (prevState) { return (__assign(__assign({}, prevState), { tipoRequerimentoDoc: value, requerentePj: undefined, procurador: undefined })); });
        }
        else {
            setRequerimento(function (prevState) { return (__assign(__assign({}, prevState), { tipoRequerimentoDoc: value, requerentePf: undefined, requerimentoInventariante: undefined })); });
        }
        requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange({});
    };
    var getOptions = function () {
        var options = TipoDocumentoOptions.getOptions();
        var requerimentoCache = LocalStorageUtils.getEncryptedDataFromLocalStorage(AuthConstants.REQUERIMENTO_CACHE);
        return options.map(function (option) {
            var _a;
            return ({
                value: option.value,
                label: "\u00C9 um requerimento para ".concat(option.label),
                disabled: option.value === TipoDocumentoEnum.PJ && ((_a = requerimentoCache === null || requerimentoCache === void 0 ? void 0 : requerimentoCache.servico) === null || _a === void 0 ? void 0 : _a.referenciaServico) === TipoProcessoEnum.DECLARACAO_ASSENTADO,
            });
        });
    };
    return (_jsx(Box, __assign({ sx: { p: 0, background: 'transparent' } }, { children: _jsx(RequerimentoCustomRadioGroup, { value: tipoRequerenteDoc, mob: "mob", onChange: handleChange, sx: { flexDirection: "column" }, options: getOptions() }) })));
};
